import { ViewMoreMenuType } from "@lifepal/lifepal-design-system/build/components/ViewMore";

export const VIEW_MORE_MENU: ViewMoreMenuType[] = [
  {
    id: 3,
    title: 'Asuransi',
    spriteSelector: '--insurance',
  },
  {
    id: 2,
    title: 'Tools',
    spriteSelector: '--tools',
  },
  {
    id: 1,
    title: 'Explore',
    spriteSelector: '--explore',
  },
];
